import React, { ReactNode } from 'react';
import { IconNameEnum } from '@app/common';
import { IconChartBarFilled } from '../components/app/icons/chart-bar-filled';
import { IconChartBar } from '../components/app/icons/chart-bar';
import { IconHeartFilled } from '../components/app/icons/heart-filled';
import { IconHeart } from '../components/app/icons/heart';
import { IconDividendsFilled } from '../components/app/icons/dividends-filled';
import { IconDividends } from '../components/app/icons/dividends';
import { IconProfitsFilled } from '../components/app/icons/profits-filled';
import { IconProfits } from '../components/app/icons/profits';
import { IconTradesFilled } from '../components/app/icons/trades-filled';
import { IconTrades } from '../components/app/icons/trades';
import { IconWalletFilled } from '../components/app/icons/wallet-filled';
import { IconWallet } from '../components/app/icons/wallet';
import { IconAccountingDocument } from '../components/app/icons/accounting-document';
import { IconBell } from '../components/app/icons/bell';
import { IconBellFilled } from '../components/app/icons/bell-filled';
import { IconCompoundInterest } from '../components/app/icons/compound-interest';

const iconMap: Record<IconNameEnum, ReactNode> = {
    [IconNameEnum.Wallet]: <IconWallet />,
    [IconNameEnum.WalletFilled]: <IconWalletFilled />,
    [IconNameEnum.Profits]: <IconProfits />,
    [IconNameEnum.ProfitsFilled]: <IconProfitsFilled />,
    [IconNameEnum.Trades]: <IconTrades />,
    [IconNameEnum.TradesFilled]: <IconTradesFilled />,
    [IconNameEnum.Dividends]: <IconDividends />,
    [IconNameEnum.DividendsFilled]: <IconDividendsFilled />,
    [IconNameEnum.AccountingDocument]: <IconAccountingDocument />,
    [IconNameEnum.Bell]: <IconBell />,
    [IconNameEnum.BellFilled]: <IconBellFilled />,
    [IconNameEnum.ChartBar]: <IconChartBar />,
    [IconNameEnum.ChartBarFilled]: <IconChartBarFilled />,
    [IconNameEnum.Heart]: <IconHeart />,
    [IconNameEnum.HeartFilled]: <IconHeartFilled />,
    [IconNameEnum.CompoundInterest]: <IconCompoundInterest />,
};

export function getIcon(type: IconNameEnum): ReactNode | null {
    return iconMap[type] ?? null;
}
